var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBtc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.604 13.06c.472-3.152-1.928-4.847-5.21-5.977l1.065-4.27-2.6-.648-1.037 4.158c-.683-.17-1.385-.33-2.083-.49l1.044-4.185L16.187 1 15.12 5.27a86.02 86.02 0 0 1-1.658-.391l.003-.015L9.88 3.97 9.19 6.746c-.001 0 1.927.442 1.887.47 1.052.262 1.242.96 1.21 1.511l-1.212 4.865c.073.018.167.045.27.087l-.274-.07-1.7 6.815c-.128.32-.454.8-1.19.618.026.038-1.89-.472-1.89-.472L5 23.548l3.383.843c.629.158 1.246.323 1.853.478l-1.076 4.32 2.597.647 1.065-4.273c.71.192 1.397.37 2.071.537l-1.061 4.252 2.6.648 1.075-4.31c4.432.838 7.765.5 9.167-3.51 1.13-3.227-.056-5.09-2.388-6.303 1.699-.392 2.977-1.51 3.318-3.817zm-5.939 8.328c-.803 3.228-6.238 1.483-8 1.045l1.428-5.722c1.762.441 7.412 1.312 6.572 4.678zm.804-8.375c-.733 2.937-5.257 1.445-6.724 1.08l1.294-5.19c1.467.365 6.192 1.048 5.43 4.11z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtc);
export default __webpack_public_path__ + "static/media/BTC.aac0e262094a29b50212850eb42939a1.svg";
export { ForwardRef as ReactComponent };